import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/personnel-types/PersonnelTypesAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { PersonnelTypeEditForm } from "./PersonnelTypeEditForm";

export function PersonnelTypeEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, personnelType } = useSelector(
    (state) => ({
      actionsLoading: state.personnelTypes.actionsLoading,
      isSuccess: state.personnelTypes.isSuccess,
      type: state.personnelTypes.type,
      personnelType: state.personnelTypes.personnelType
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getPersonnelType(id));
    return () => dispatch(actions.cleanPersonnelTypesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Personel Türü";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  const savePersonnelType = (values) => {
    dispatch(actions.savePersonnelType(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/personel-turleri`), 2500);
  };

  const btnRef = useRef();  
  const savePersonnelTypeClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <PersonnelTypeEditForm 
            personnelType={personnelType}
            btnRef={btnRef} 
            savePersonnelType={savePersonnelType}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={savePersonnelTypeClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}